<template>
  <div class="style-tab-button">
    <ul class="editor-design">
      <li>
        ボタン
      </li>
      <!-- ボタンの幅 -->
      <li class="flex-box end">
        <select-box
          :target="'width'"
          :value="width"
          @updateAttrs="updateAttrs($event)"
        />
        <!-- 揃え位置 -->
        <select-button
          :target="'margin'"
          :value="value['margin']"
          :disabled="width === '100%'"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 背景色 -->
      <li class="flex-box">
        <select-color
          :type="'part'"
          :target="'background'"
          :selector="null"
          :value="value['background']"
          @updateStyles="updateStyles($event)"
        />
      <!-- 罫線 -->
        <select-border
          :type="'part'"
          :target="'border'"
          :value="value['border-top']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 角の丸み -->
      <li class="flex-box">
        <range-border-radius
          :target="'border-radius'"
          :unit="'px'"
          :value="value['border-radius']"
          :type="partType"
          :attrs="null"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 余白（外側：上下） -->
      <li class="flex-box">
        <slider
          :prop="'padding-top'"
          :value="value['padding-top']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 余白（外側：左右） -->
      <li class="flex-box">
        <slider
          :prop="'padding-right'"
          :value="value['padding-right']"
          @updateStyles="updateStyles($event)"
        />
      </li>
      <!-- 余白（内側） -->
      <li class="flex-box">
        <slider
          :prop="'inner-padding'"
          :value="value['inner-padding']"
          @updateStyles="updateStyles($event)"
        />
      </li>
    </ul>
  </div>
</template>

<script>
import SelectBox from '@/components/Content/Palette/CommonLayouts/EditStyleSelectBox'
import SelectColor from '@/components/Content/Palette/CommonLayouts/EditStyleSelectColor'
import SelectBorder from '@/components/Content/Palette/CommonLayouts/EditStyleBorder'
import SelectButton from '@/components/Content/Palette/CommonLayouts/EditStyleSelectButton'
import RangeBorderRadius from '@/components/Content/Palette/CommonLayouts/EditStyleBorderRadius'
import Slider from '@/components/Content/Palette/CommonLayouts/EditStyleSlider'

export default {
  props: [
    'value',
    'width',
    'sectionId',
    'partsContainerId',
    'partId',
    'partType',
  ],
  components: {
    SelectBox,
    SelectColor,
    SelectBorder,
    SelectButton,
    RangeBorderRadius,
    Slider,
  },
  methods: {
    updateStyles (styles) {
      this.$store.commit('updatePartStyles', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        styles: styles
      })
    },
    updateAttrs (attrs) {
      this.$store.commit('updatePartAttrs', {
        sectionId: this.sectionId,
        partsContainerId: this.partsContainerId,
        partId: this.partId,
        attrs: attrs
      })
    },
  }
}
</script>

<style lang="scss">
  .style-tab-button {
    .flex-box {
      .common-select {
        margin-right: 0;
      }
      &.end {
        align-items: flex-end;
      }
    }
    .edit-style-border-radius {
      margin: 0;
    }
  }
</style>
